const TaiwanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112512)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C6.86953 13.1305 12.6956 7.30438 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#D80027"
      />
      <path d="M20 20C20 8.95437 20 7.65219 20 0C8.95437 0 0 8.95437 0 20H20Z" fill="#0052B4" />
      <path
        d="M17.3915 11.7059L14.9489 12.855L16.2495 15.2205L13.5973 14.713L13.2611 17.3925L11.4138 15.4219L9.56627 17.3925L9.23025 14.713L6.57791 15.2204L7.87854 12.8548L5.43604 11.7059L7.87861 10.5571L6.57791 8.19148L9.23018 8.69891L9.56635 6.01953L11.4138 7.99016L13.2612 6.01953L13.5973 8.69891L16.2496 8.19148L14.9489 10.5572L17.3915 11.7059Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.4138 15.4272C13.4699 15.4272 15.1367 13.7604 15.1367 11.7043C15.1367 9.64824 13.4699 7.98145 11.4138 7.98145C9.35771 7.98145 7.69092 9.64824 7.69092 11.7043C7.69092 13.7604 9.35771 15.4272 11.4138 15.4272Z"
        fill="#0052B4"
      />
      <path
        d="M11.4138 13.6892C10.32 13.6892 9.43018 12.7993 9.43018 11.7054C9.43018 10.6116 10.3201 9.72168 11.4138 9.72168C12.5077 9.72168 13.3976 10.6116 13.3976 11.7054C13.3975 12.7993 12.5075 13.6892 11.4138 13.6892Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112512">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TaiwanSvg;
